<template>
  <v-combobox
    v-bind="$attrs"
    :readonly="regions.length === 0"
    :items="regions"
    :loading="loading"
    v-model="region"
    :return-object="false"
    @change="change"
  />
</template>

<script>
export default {
  name: 'RegionSelect',

  props: {
    value: {
      type: [String, null],
      default: null
    },
    country: {
      type: [String, null],
      default: null
    }
  },

  data () {
    return {
      region: this.value,
      regions: [],
      loading: false
    }
  },

  watch: {
    country: async function () {
      await this.loadRegions()
      if (this.regions.includes(this.value)) {
        this.region = this.value
      } else {
        this.region = null
      }

      this.change()
    }
  },

  async mounted () {
    await this.loadRegions()
  },

  methods: {
    change () {
      this.$emit('input', this.region)
    },

    async loadRegions () {
      if (!this.country) {
        return
      }

      this.loading = true
      this.regions = await this.$http.make('country').getRegions(this.country)
      this.loading = false
    }
  }
}
</script>
